// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__vXzsO","signatureButtonsRight":"ModalSign_signatureButtonsRight__2tu2v"};